import { render } from "./EducationalActivityModal.vue?vue&type=template&id=2a453af3&scoped=true"
import script from "./EducationalActivityModal.vue?vue&type=script&lang=js"
export * from "./EducationalActivityModal.vue?vue&type=script&lang=js"

import "./EducationalActivityModal.vue?vue&type=style&index=0&id=2a453af3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a453af3"]])

export default __exports__